import React, { useState } from "react";
import BookingConfirmPage from "../pages/bookingConfirmPage";

const BookingConfirmModal = ({
  data,
  isModalOpen,
  setIsModalOpen,
  userDetails,
  fetchData,
  setIsShareModalOpen
}) => {
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    // fetchData();
  };

  return (
    <div className="">
      {/* Button to open the modal */}
      {/* <button
        onClick={openModal}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Open Booking Confirmation
      </button> */}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50">
          <div className="">
            {/* Modal content */}
            <BookingConfirmPage
              data={data}
              closeModal={closeModal}
              userDetails={userDetails}
              setIsShareModalOpen={setIsShareModalOpen}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingConfirmModal;
